module.exports = __webpack_public_path__ + "static/img/defalut.184ce8df.jpg";